import { render } from "./Cubagem.vue?vue&type=template&id=4fdcaf26&scoped=true"
import script from "./Cubagem.vue?vue&type=script&lang=js"
export * from "./Cubagem.vue?vue&type=script&lang=js"

import "./Cubagem.vue?vue&type=style&index=0&id=4fdcaf26&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fdcaf26"]])

export default __exports__